import React, { useContext, useEffect, useState } from "react";
import { decodeToken } from "react-jwt";
import WaterMark from "../../../Dashboard/DashboardMain/WaterMark";
import AppContext from "../../../../store/AppContext";
import { useDispatch } from "react-redux";
import { setLoggedInUser } from "../../../../redux/userSlice";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates";
import useHttp from "../../../../hook/use-http";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { ThreeCircles } from 'react-loader-spinner';
import { setCityAndDepo } from "../../../../redux/cityDepoSlice";
import { formatTo12Hour, subtractTime } from "../../../../util/dateTimeUtils";
import Real_time_vehicles from "./Real_time_vehicles";
import Vehicle_Data_Table from "./Vehicle_Data_Table";
import Vehicle_Data_Table_Charging from "./Vehicle_Data_Table_Charging";
import CustomModal from "../../../Shared/CustomModal";


// let vehicle_data = [];
let vehicle_data_charging = [];
let flag = false;
let total_vehicle_count_data = 0
let total_vehicle_Count_charging_ = 0
let total_vehicle_Count_charging_Z = 0
let total_count_charging_offline = 0
let vehicle_per = 0
let vehicle_per_charging = 0
let vehicleCountData = 30
let vehicleCountData_charging = 30
let real_time_array = []
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function HomePage({ apiend }) {
    // const app_ctx = useContext(AppContext);
    const [isActive, setIsActive] = useState(false);
    const [isActiveCharging, setIsActiveCharging] = useState(false);
    // const [excelData, setexcelData] = useState([]);
    // const [excelDataCharging, setexcelDataCharging] = useState([]);
    const [isActionEnable, setIsActionEnable] = useState(false);
    // const [isActionEnableFleetEv, setIsActionEnableFleetEv] = useState(false);
    // const [DataVehicle, setDataVehicle] = useState(0)
    const [vehicle_data, setVehicle_data] = useState([])
    let [FileName, setFileName] = useState("offline vehicle")
    const [refresh_date, setRefreshDate] = useState()
    let flag1 = true
    let flag2 = true
    let flag3 = true
    apiend = "offlinedata";


    const token = JSON.parse(sessionStorage.user || localStorage.user);

    let myDecodedToken = decodeToken(token.token);

    let ev_bus = myDecodedToken.ev_bus;
    const hideShow = ev_bus.split("_");
    const flagForHideShow = hideShow[0];
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const usernameNew = myDecodedToken.access_type;
    // var split_str = usernameNew.split(",")
    var split_str = usernameNew ? usernameNew.split(",") : "";

    const city_name = myDecodedToken.city_name;
    const city_name_arr = city_name === "" ? [] : city_name.split(",");
    const depo_name = myDecodedToken.depo_name;
    const depo_name_arr = depo_name === "" ? [] : depo_name.split(",");

    // code for redux
    // After a successful login
    const user = { flagForHideShow };
    const dispatch = useDispatch();
    dispatch(setLoggedInUser(user));
    dispatch(setCityAndDepo({ city: city_name_arr, depot: depo_name_arr }));
    // code for redux

    const appyDataCount_offline = (data) => {
        total_vehicle_count_data = 0
        vehicle_per = 0
        total_vehicle_count_data = data[0].offline_day.value
        total_count_charging_offline = data[0].doc_count
        vehicle_per = (total_vehicle_count_data / total_count_charging_offline) * 100;
        // if (ev_bus === "ERC_ACE") {
        fetchData({ url: API_URL_MAIN + "offline_coral/offline_vehicle", body: { count: textboxvalue_x } }, appyOffineData);
        // }
    }
    const appyDataCount_charging = (data) => {
        total_vehicle_Count_charging_ = 0
        vehicle_per_charging = 0
        total_vehicle_Count_charging_ = data[0].last_charge_day.value
        total_count_charging_offline = data[0].doc_count
        vehicle_per_charging = (total_vehicle_Count_charging_ / total_count_charging_offline) * 100;
        // if (ev_bus === "ERC_ACE") {
        fetchData({ url: API_URL_MAIN + "offline_coral/offline_charging", body: { count: textboxvalue_y } }, appyOffineData_charging);
        // }
    }
    const appyData = (data) => {
        setRefreshDate(data.value_as_string);
    }
    useEffect(() => {
        if (split_str.indexOf("10") !== -1) {
            setIsActionEnable(true);
        }
        // if (split_str.indexOf("12") !== -1) {
        // setIsActionEnableFleetEv(true);
        // }
    }, [isActionEnable]);

    useEffect(() => {
        fetchData({ url: API_URL_MAIN + "refreshdate/action_insights_coral" }, appyData)
    }, []);
    useEffect(() => {
        if (vehicleCountData === 30) {
            fetchData({ url: API_URL_MAIN + "offline_coral/offline_count", body: { count: vehicleCountData } }, appyDataCount_offline)
        }
    }, [vehicleCountData])
    useEffect(() => {
        if (vehicleCountData_charging === 30) {
            fetchData({ url: API_URL_MAIN + "offline_coral/offline_count", body: { count: vehicleCountData_charging } }, appyDataCount_charging)
        }
    }, [vehicleCountData_charging])
    const sortByKey = (data, type) => {
        let key
        if (type === "offline")
            key = "Days_since_unavailability_Days"
        else
            key = "Last_charge_day"
        const sortedData = [...data].sort((a, b) => {
            if (a[key] < b[key]) return 1;
            if (a[key] > b[key]) return -1;
            return 0;
        });
        return sortedData
    }
    const appyOffineData = (data) => {
        let data_vehicle = data;
        let vehicle_data = []
        for (let i = 0; i < data_vehicle.length; i++) {
            if (data_vehicle[i]._source.offline_day > textboxvalue_x) {
                // if (ev_bus === "ERC_ACE") {
                vehicle_data.push({
                    VIN: data_vehicle[i]?._source.vehicleId || "",
                    CITY: data_vehicle[i]?._source.DLR_ORG_CITY || "",
                    First_data_received: data_vehicle[i]?._source.First_eventdate || "",
                    Last_data_received: data_vehicle[i]?._source.eventdate || "",
                    Last_SOC_received: data_vehicle[i]?._source.state_of_charge_soc || "",
                    Days_since_unavailability_Days: data_vehicle[i]?._source.offline_day || "",
                });
                // }
                // else {
                //     vehicle_data.push({
                //         VIN: data_vehicle[i]._source.vehicleId,
                //         Sim_Status: data_vehicle[i]._source.sim_status,
                //         DLR_REGION: data_vehicle[i]._source.DLR_REGION,
                //         DLR_STATE: data_vehicle[i]._source.DLR_STATE,
                //         LOB: data_vehicle[i]._source.LOB,
                //         PPL: data_vehicle[i]._source.PPL,
                //         PL: data_vehicle[i]._source.PL,
                //         ignitionOn: data_vehicle[i]._source.ignitionOn,
                //         crankOn: data_vehicle[i]._source.crankOn,
                //         Speed: data_vehicle[i]._source.Speed,
                //         gpsFix: data_vehicle[i]._source.gpsFix,
                //         packetStatus: data_vehicle[i]._source.packetStatus,
                //         signalStrength: data_vehicle[i]._source.signalStrength,
                //         signalProviderName: data_vehicle[i]._source.signalProviderName,
                //         odometer: data_vehicle[i]._source.odometer,
                //         gpsSignalQuality: data_vehicle[i]._source.gpsSignalQuality,
                //         gpsLatitude: data_vehicle[i]._source.gpsLatitude,
                //         gpsLongitude: data_vehicle[i]._source.gpsLongitude,
                //         CITY: data_vehicle[i]._source.DLR_ORG_CITY,
                //         First_data_received: data_vehicle[i]._source.First_eventdate,
                //         Last_data_received: data_vehicle[i]._source.eventdate,
                //         Last_SOC_received: data_vehicle[i]._source.state_of_charge_soc,
                //         Days_since_unavailability_Days: data_vehicle[i]._source.offline_day,
                //     });
                // }
            }
        }

        vehicle_data = sortByKey(vehicle_data, "offline")
        setVehicle_data(vehicle_data)
        // setexcelData(vehicle_data);
    };
    const appyOffineData_charging = (data) => {
        let data_vehicle = data;
        vehicle_data_charging = []
        for (let i = 0; i < data_vehicle.length; i++) {
            if (data_vehicle[i]._source.last_charge_day > textboxvalue_y) {
                vehicle_data_charging.push({
                    VIN: data_vehicle[i]._source.vehicleId,
                    CITY: data_vehicle[i]._source.DLR_ORG_CITY,
                    Last_charged_date: data_vehicle[i]._source.last_charged_date,
                    ChargeType: data_vehicle[i]._source.chargeType,
                    soc_end: data_vehicle[i]._source.soc_end,
                    Last_SOC_received: data_vehicle[i]._source.state_of_charge_soc,
                    Last_charge_day: data_vehicle[i]._source.last_charge_day,
                });
            }
        }
        vehicle_data_charging = sortByKey(vehicle_data_charging, "charging")
        // setexcelDataCharging(vehicle_data_charging);
    };
    useEffect(() => {
        fetchData({ url: API_URL_MAIN + "offline_coral/offline_vehicle", body: { count: vehicleCountData } }, appyOffineData)
    }, [])
    useEffect(() => {
        fetchData({ url: API_URL_MAIN + "offline_coral/offline_charging", body: { count: vehicleCountData_charging } }, appyOffineData_charging)
    }, [])
    useEffect(() => {
        if (isActive) {
            const keyEnter = (event) => {
                if (event.key === "Enter") {
                    fetchData({ url: API_URL_MAIN + "offline_coral/offline_vehicle", body: { count: vehicleCountData } }, appyOffineData);
                    fetchData({ url: API_URL_MAIN + "offline_coral/offline_count", body: { count: vehicleCountData } }, appyDataCount_offline)
                }
            };

            document.addEventListener("keydown", keyEnter);
            return () => {
                document.removeEventListener("keydown", keyEnter);
            };
        }

    }, [isActive, vehicleCountData]);
    useEffect(() => {
        // if (ev_bus == "ERC_ACE") {
        if (isActiveCharging) {
            const keyEnter = (event) => {
                if (event.key === "Enter") {
                    fetchData({ url: API_URL_MAIN + "offline_coral/offline_charging", body: { count: vehicleCountData_charging } }, appyOffineData_charging);
                    fetchData({ url: API_URL_MAIN + "offline_coral/offline_count", body: { count: vehicleCountData_charging } }, appyDataCount_charging)
                }
            };

            document.addEventListener("keydown", keyEnter);
            return () => {
                document.removeEventListener("keydown", keyEnter);
            };
        }

        // } else {
        //     if (isActiveCharging) {
        //         const keyEnter = (event) => {
        //             if (event.key === "Enter") {
        //                 fetchData({ url: API_URL_MAIN + "offline_coral/offline_charging", body: { count: vehicleCountData_charging } }, appyOffineData_charging);
        //             }
        //         };

        //         document.addEventListener("keydown", keyEnter);
        //         return () => {
        //             document.removeEventListener("keydown", keyEnter);
        //         };
        //     }
        // }
    }, [isActiveCharging, ev_bus, vehicleCountData_charging]);

    const [istextbox_x, setIsTextBox_X] = useState(true);
    const [istextbox_y, setIsTextBox_Y] = useState(true);
    const [textboxvalue_x, setTextBoxValue_X] = useState(30);
    const [textboxvalue_y, setTextBoxValue_Y] = useState(30);

    const handlechange_x = (e) => {
        setTextBoxValue_X(parseInt(e.target.value))
    }
    const handlechange_y = (e) => {
        setTextBoxValue_Y(parseInt(e.target.value))
    }
    const handleclick_x = (e) => {
        setIsTextBox_X(true)
        setIsTextBox_Y(false)
        setIsTextBox_Z(false)
        setTextBoxValue_X(parseInt(e.target.value))
    }
    const handleclick_y = (e) => {
        setIsTextBox_X(false)
        setIsTextBox_Y(true)
        setIsTextBox_Z(false)
        setTextBoxValue_Y(parseInt(e.target.value))
    }
    const onkeydown_x = (e) => {
        if (e.key === "Enter") {
            fetchData({ url: API_URL_MAIN + "offline_coral/offline_count", body: { count: textboxvalue_x } }, appyDataCount_offline)
        }
    }
    const onkeydown_y = (e) => {
        if (e.key === "Enter") {
            fetchData({ url: API_URL_MAIN + "offline_coral/offline_count", body: { count: textboxvalue_y } }, appyDataCount_charging)
        }
    }
    const handleclick_fleet = (e) => {
        // alert(e.target.outerText)
        const count = parseInt(e.target.outerText)
        flag1 = true;
        flag2 = false
        // setDataVehicle(parseInt(e.target.outerText))
        setFileName("offline vehicle")
    };

    const handleclick_charging_fleet = (e) => {
        flag2 = true
        flag1 = false
        // setDataVehicle(parseInt(e.target.outerText))
        setFileName("Not Charged Vehicles")
        const et = e.target.value;
    };
    const excelFileName = FileName

    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    let loader = (<div style={{ margin: "auto" }}><ThreeCircles
        height="25"
        width="25"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="three-circles-rotating"
        outerCircleColor="#3498db"
        innerCircleColor="#dec52d"
        middleCircleColor="#db213a"
    /></div>)

    //                  Sidd------------------start     --------------------------------------

    const [nume, setNume] = useState();
    const [deno, setDeno] = useState();
    const [ascents_percentage, setAscentsPercentage] = useState(0);
    // const [inputValue, setInputValue] = useState(30);
    const [csvInsightData, setcsvInsightData] = useState();

    useEffect(() => {
        fetchData({ url: API_URL_MAIN + "ascentev_action_insights/getactioninsight", body: {} }, ascent_getdata)

        fetchData({ url: API_URL_MAIN + "ascentev_action_insights/getxlsxdata", body: { selectedday: 30 } }, defaultcsvdata)
    }, []);

    useEffect(() => {
        if (nume !== undefined && deno !== undefined) {
            calculatePercentage();
        }
    }, [nume, deno]);

    const ascent_getdata = (data) => {
        setNume(data.offline_day_value)
        setDeno(data.total_count)
    }

    const calculatePercentage = () => {
        if (deno !== 0) {
            const calculatedPercentage = (nume / deno) * 100;
            setAscentsPercentage(calculatedPercentage);
        } else {
            console.error("Error: Division by zero");
        }
    };






    const defaultcsvdata = (data) => {
        setcsvInsightData(data);
    }


    const buttonClicked = () => {
        fetchData({ url: API_URL_MAIN + "auth/logging", body: { page_name: "actioninsights" } }, [])
    }

    const [real_time_data, setreal_time_data] = useState([]);
    const [istextbox_z, setIsTextBox_Z] = useState(true);
    const [textboxvalue_z, setTextBoxValue_Z] = useState(10);
    const [RealTImeVehicles, setRealTImeVehicles] = useState(0)
    // const [istextbox_a, setIsTextBox_A] = useState(true);
    const handleclick_charging_fleet_1 = (e) => {
        // fetchData({ url: API_URL_MAIN + "real_time_fault_code/soc_excel", body: { socCount: textboxvalue_z } }, appyDataCount_charging_1)
        flag3 = true
        flag2 = false
        flag1 = false
        // setDataVehicle(parseInt(e.target.outerText))
        setFileName("Low SOC Vehicle Details")
    };
    const appyDataCount_charging_1 = (data) => {
        if (data.length > 0) {
            setRealTImeVehicles(data.length)
            setreal_time_data(data)
        } else {
            setRealTImeVehicles(0)
            setreal_time_data([])
        }
        real_time_array = []
        for (let i = 0; i < data.length; i++) {
            real_time_array.push({
                vehicleId: data[i]._source.vehicleId,
                DLR_ORG_CITY: data[i]._source.DLR_ORG_CITY,
                Distance_to_Empty: data[i]._source.Distance_to_Empty,
                DLR_REGION: data[i]._source.DLR_REGION,
                BMS_Pack_SOH: data[i]._source.BMS_Pack_SOH,
                State_of_Charge_SOC: data[i]._source.State_of_Charge_SOC,
            });
        }
    }
    const handlechange_z = (e) => {
        setTextBoxValue_Z(parseInt(e.target.value))
    }
    const handleclick_z = (e) => {
        setIsTextBox_X(false)
        setIsTextBox_Y(false)
        setIsTextBox_Z(true)
        setTextBoxValue_Z(parseInt(e.target.value))
    }


    const now = new Date();
    // Get 30 minutes ago
    const thirtyMinutesAgo = subtractTime(now, { minutes: 30 });
    const thirtyMinuteMinus = formatTo12Hour(thirtyMinutesAgo);

    const onkeydown_z = (e) => {
        if (e.key === "Enter") {
            fetchData({ url: API_URL_MAIN + "coral_dic/soc_excel", body: { socCount: textboxvalue_z, thirtyMinuteMinus: thirtyMinuteMinus } }, appyDataCount_charging_1)
        }
    }

    useEffect(() => {
        fetchData({ url: API_URL_MAIN + "coral_dic/soc_excel", body: { socCount: textboxvalue_z, thirtyMinuteMinus: thirtyMinuteMinus } }, appyDataCount_charging_1)
    }, [])




    const exportToExcel = async () => {

        if (FileName === "offline vehicle") {
            const ws = XLSX.utils.json_to_sheet(vehicle_data);
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, excelFileName + fileExtension);

            fetchData({ url: API_URL_MAIN + "auth/logging", body: { page_name: "Action_data_off_down" } }, [])
        } else if (FileName === "Not Charged Vehicles") {

            const ws = XLSX.utils.json_to_sheet(vehicle_data_charging);
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, excelFileName + fileExtension);

            fetchData({ url: API_URL_MAIN + "auth/logging", body: { page_name: "Action_data_charge_down" } }, [])
        } else {
            const ws = XLSX.utils.json_to_sheet(real_time_array);
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, excelFileName + fileExtension);

            fetchData({ url: API_URL_MAIN + "auth/logging", body: { page_name: "realtimedata" } }, [])
        }
    }


    return (
        <>
            <div>
                {isActionEnable && (
                    <div class="accordion" id="accordionExample" >
                        <div class="accordion-item" >
                            <h2 class="accordion-header" id="headingOne">
                                <button id="action" class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" style={{ border: "1px solid #358696", paddingTop: "0px", paddingBottom: "0px", }} onClick={buttonClicked}>
                                    <img
                                        src="/assets/images/AC4.png" style={{ marginRight: "12px", height: "45px", width: "50px" }}
                                    />
                                    <b>Action Insights</b>
                                </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                <div class="accordion-body" style={{ textAlignLast: "end", paddingBottom: 0 }} ><strong style={{ fontSize: 12 }}>Last Refresh Date : {refresh_date}</strong></div>
                                <div class="accordion-body" style={{ textAlignLast: "start", paddingBottom: "6px", paddingTop: "6px" }}>
                                    <img src="/assets/images/offine_green.png" style={{ marginRight: "12px", width: "32px", marginTop: "-15px", marginRight: "0px" }} />
                                    <strong class="btn btn" data-toggle="modal" data-target="#ActionInsightCoral1" onClick={handleclick_fleet} style={{ color: "#358696", height: "34px", marginTop: "-3px" }}>
                                        {istextbox_x ?
                                            <>
                                                {isLoading ? loader :
                                                    <h5>
                                                        <b>{total_vehicle_count_data}</b>
                                                    </h5>
                                                }
                                            </> :
                                            <h5>
                                                <b>{total_vehicle_count_data}</b>
                                            </h5>
                                        }
                                    </strong>
                                    <span>({vehicle_per.toFixed(2)}%)</span>
                                    <strong>Vehicles are offline for more than </strong>{" "}

                                    <input type="text" defaultValue={30} style={{ width: "35px" }} onClick={handleclick_x} onKeyDown={onkeydown_x} onChange={handlechange_x} onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))} />
                                    <strong>&nbsp;days.</strong>
                                </div>
                                <div class="accordion-body" style={{ textAlignLast: "start", paddingBottom: "6px", paddingTop: "6px" }} >
                                    <img src="/assets/images/charging_green.png" style={{ marginRight: "0px", width: "39px", marginTop: "-12px" }} />
                                    <strong class="btn btn" data-toggle="modal" data-target="#ActionInsightCoral1" onClick={handleclick_charging_fleet} style={{ color: "#358696", height: "34px", marginTop: "-3px" }}>
                                        {istextbox_y ?
                                            <>
                                                {isLoading ? loader :
                                                    <h5>
                                                        <b>{total_vehicle_Count_charging_}</b>
                                                    </h5>
                                                }
                                            </> :
                                            <h5>
                                                <b>{total_vehicle_Count_charging_}</b>
                                            </h5>
                                        }
                                    </strong>
                                    <span>({vehicle_per_charging.toFixed(2)}%)</span>
                                    <strong> Vehicles not charged for more than</strong>{" "}
                                    <input type="text" defaultValue={30} style={{ width: "35px" }} onClick={handleclick_y} onKeyDown={onkeydown_y} onChange={handlechange_y} onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))} />{" "}
                                    <strong>days.</strong>
                                </div>

                                <div class="accordion-body" style={{ textAlignLast: "start", paddingBottom: "6px", paddingTop: "6px" }} >
                                    <img src="/assets/images/real_time.png" style={{ marginRight: "0px", width: "39px", marginTop: "-12px" }} />
                                    <strong class="btn btn" data-toggle="modal" data-target="#ActionInsightCoral1" onClick={handleclick_charging_fleet_1} style={{ color: "#358696", height: "34px", marginTop: "-3px" }}>
                                        {istextbox_z ?
                                            <>
                                                {isLoading ? loader :
                                                    <h5>
                                                        <b>{RealTImeVehicles}</b>
                                                    </h5>
                                                }
                                            </> :
                                            <h5>
                                                <b>{RealTImeVehicles}</b>
                                            </h5>
                                        }
                                    </strong>
                                    {/* <span>({vehicle_per_charging.toFixed(2)}%)</span> */}
                                    <strong>Vehicle with SOC less than </strong>{" "}
                                    <input type="text" defaultValue={10} style={{ width: "35px" }} onClick={handleclick_z} onKeyDown={onkeydown_z} onChange={handlechange_z} onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))} />{" "}
                                    <strong>% <span style={{ fontSize: "10px", color: 'gray' }}>(realtime)</span>.</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <WaterMark />
                <CustomModal id={"ActionInsightCoral1"} title={capitalizeFirstLetter(FileName)} size="modal-lg" closeBtn={false}>
                    <div /* class="modal-body" */ style={{ overflowY: "scroll", height: "350px", }}>
                        {FileName === "offline vehicle" &&
                            <table className="table table-striped">

                                <thead style={{ backgroundColor: "#358696", color: "#fff", position: "sticky", zIndex: 1 }}>
                                    <tr>
                                        <th scope="col">Sr.No</th>
                                        <th scope="col">Vin Number</th>
                                        <th scope="col">City</th>
                                        <th scope="col">First data received</th>
                                        <th scope="col">Last data received</th>
                                        <th scope="col">Last SOC received (%)</th>
                                        <th scope="col">Days since unavailability (Days)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <Vehicle_Data_Table_Charging data={vehicle_data} />
                                </tbody>
                            </table>
                        }
                        {FileName === "Not Charged Vehicles" &&
                            <table className="table table-striped">

                                <thead style={{ backgroundColor: "#358696", color: "#fff", position: "sticky", zIndex: 1, top: "-17px" }} >
                                    <tr>
                                        <th scope="col">Sr.No</th>
                                        <th scope="col">Vin Number</th>
                                        <th scope="col">City</th>
                                        <th scope="col">Last charge date</th>
                                        <th scope="col">Last charge type</th>
                                        <th scope="col">SOC end after charging (%)</th>
                                        <th scope="col">Last SOC received (%)</th>
                                        <th scope="col">Days since Last charge (days)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <Vehicle_Data_Table data={vehicle_data_charging} />
                                </tbody>
                            </table>
                        }

                        {FileName === "Low SOC Vehicle Details" &&
                            <table className="table table-striped">

                                <thead style={{ backgroundColor: "#358696", color: "#fff", position: "sticky", zIndex: 1, top: "-17px" }} >
                                    <tr>
                                        <th scope="col">Sr.No</th>
                                        <th scope="col">Vin Number</th>
                                        <th scope="col">City</th>
                                        <th scope="col">Distance to Empty</th>
                                        <th scope="col">Region</th>
                                        <th scope="col">BMS Pack SOH</th>
                                        <th scope="col">SOC</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <Real_time_vehicles data={real_time_data} />
                                </tbody>
                            </table>
                        }
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" onClick={exportToExcel}>
                            DOWNLOAD
                        </button>
                        {/* </a> */}
                        <button type="button" class="btn btn-default" data-dismiss="modal" >
                            CLOSE
                        </button>
                    </div>
                </CustomModal>
            </div>

        </>
    );



}

export default HomePage;
